import React from "react";

const LogoSlider = ({ data, title, desc }) => {
  return (
    <>
      <div className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 mx-auto text-center">
              <h2 className="textt-gradient bg-primary mb-0">{desc}</h2>
            </div>
          </div>
          <div className="row mt-4">
            {data.map((item) => {
              return (
                <div
                  className="col-lg-2 col-md-4 col-6 mb-4 certificate-logo"
                  data-aos="zoom-out"
                >
                  <img
                    className="w-80 opacity-9"
                    src={`./images/${title}/${item.img}`}
                    alt="logo"
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default LogoSlider;
